import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import { useHub } from "./HubPage";

// En-tête de page premium standardisé (KAIZEN SYSTEM).
// Titre + sous-titre + fil d'Ariane (optionnel) + zone d'actions.
export function PageHeader({ title, subtitle, breadcrumbs, actions, icon: Icon }) {
  const hub = useHub();
  return (
    <div
      data-testid="page-header"
      className={`flex flex-col xl:flex-row justify-between xl:items-center gap-6 ${hub ? "mb-6 pb-4" : "mb-8 pb-6"} w-full border-b border-zinc-800/50 animate-in fade-in slide-in-from-bottom-2 duration-500`}
    >
      <div className="flex flex-col gap-1.5 min-w-0 xl:min-w-[280px]">
        {!hub && Array.isArray(breadcrumbs) && breadcrumbs.length > 0 && (
          <nav data-testid="page-header-breadcrumbs" className="flex items-center gap-1.5 text-xs text-zinc-500 font-manrope mb-1">
            {breadcrumbs.map((b, i) => (
              <span key={i} className="flex items-center gap-1.5">
                {i > 0 && <CaretRight size={11} weight="bold" className="text-zinc-700" />}
                {b.to ? (
                  <Link to={b.to} className="hover:text-amber-400 transition-colors">{b.label}</Link>
                ) : (
                  <span className="text-zinc-400">{b.label}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        <h1 className={`${hub ? "text-2xl md:text-3xl" : "text-3xl md:text-4xl"} font-bold font-cabinet tracking-tight text-zinc-50 flex items-center gap-3 truncate`}>
          {Icon && <Icon size={30} weight="duotone" className="text-amber-500 shrink-0" />}
          <span className="truncate">{title}</span>
        </h1>
        {subtitle && (
          <p className="text-sm text-zinc-400 font-manrope flex items-center gap-2">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3 flex-wrap xl:justify-end">{actions}</div>}
    </div>
  );
}

export default PageHeader;
